import { render } from "./followUp.vue?vue&type=template&id=2cd9b01c&scoped=true"
import script from "./followUp.vue?vue&type=script&lang=js"
export * from "./followUp.vue?vue&type=script&lang=js"

import "./followUp.vue?vue&type=style&index=0&id=2cd9b01c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd9b01c"],['__file',"src/views/publicModule/followUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cd9b01c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cd9b01c', __exports__)) {
    api.reload('2cd9b01c', __exports__)
  }
  
  module.hot.accept("./followUp.vue?vue&type=template&id=2cd9b01c&scoped=true", () => {
    api.rerender('2cd9b01c', render)
  })

}


export default __exports__